export default Object.freeze({
    DETAIL: 'detail',
    PLAYER: 'player'
});
